/**
 * Keyboard naming for Pizzul's tips and Guide. LTBB teaches on Windows laptops, so Windows keys are
 * the default; a Mac is only assumed when the computer says so, and anyone can switch in the Guide.
 */
const PREF_KEY = 'beat_arranger_keys_platform';

export const detectPlatform = () => {
  const platform = (typeof navigator !== 'undefined' && (navigator.userAgentData?.platform || navigator.platform)) || '';
  return /mac/i.test(platform) ? 'mac' : 'windows';
};

export const keysPlatform = () => {
  try {
    const saved = localStorage.getItem(PREF_KEY);
    if (saved === 'mac' || saved === 'windows') return saved;
  } catch (_) { /* private mode */ }
  return detectPlatform();
};

export const setKeysPlatform = (platform) => {
  try { localStorage.setItem(PREF_KEY, platform); } catch (_) { /* private mode */ }
};

/** "Ctrl" on Windows, "⌘" on Mac. */
export const modKey = (platform = keysPlatform()) => (platform === 'mac' ? '⌘' : 'Ctrl');

// Kept for older callers; the Guide (coach/guide.js) is the full reference.
export const shortcutGroups = (mod = modKey()) => [
  { title: 'Play', items: ['Space play/pause', 'R record', 'Arrows move 1 bar', 'Shift+arrows quarter note', 'L loop'] },
  { title: 'Edit', items: [`${mod}+A select all`, `${mod}+C copy`, `${mod}+V paste`, `${mod}+D duplicate clips`, `${mod}+Shift+D duplicate track`, 'Delete', `${mod}+Z undo`] },
];
